'use client';

import { useSearchParams } from 'next/navigation';

import { BigLive } from '@/modules/rankings/PlayerCard/BigLive';
import { BigNonLive } from '@/modules/rankings/PlayerCard/BigNonLive';
import { SmallLive } from '@/modules/rankings/PlayerCard/SmallLive';
import { SmallNonLive } from '@/modules/rankings/PlayerCard/SmallNonLive';

export interface PlayerCardProps {
  rank: string;
  fullName: string;
  slug: string;
  country: string;
  flagUrl: string;
  age: string;
  played: number;
  doublesPlayed: number;
  mixedPlayed: number;
  singlesPlayed: number;
  gender: string;
  points: number;
  livePoints: number;
  avatarUrl: string;
  big?: boolean;
  change: number;
  currentTournamentUrl?: string;
  currentTournamentText?: string;
  officialPoints: number;
  plusMinus?: number;
  nextPoints?: number;
  maxPoints?: number;
  uuid: string;
}

export const PlayerCard = ({
  rank,
  fullName,
  country,
  flagUrl,
  slug,
  age,
  played,
  doublesPlayed,
  mixedPlayed,
  singlesPlayed,
  gender,
  points,
  livePoints,
  avatarUrl,
  big,
  change,
  currentTournamentUrl,
  currentTournamentText,
  officialPoints,
  plusMinus,
  nextPoints,
  maxPoints,
  uuid,
}: PlayerCardProps) => {
  const searchParams = useSearchParams();

  const live = searchParams?.get('live') ?? '';
  const isCurrentSeed = searchParams?.get('ranking_type') === 'currentSeed';
  const playerRedirectURL = `/rankings/players/${slug || uuid}?type=player-profile`;

  return !live ? (
    big ? (
      <BigNonLive
        rank={rank}
        age={age}
        fullName={fullName}
        country={country}
        avatarUrl={avatarUrl}
        flagUrl={flagUrl}
        played={played}
        doublesPlayed={doublesPlayed}
        mixedPlayed={mixedPlayed}
        singlesPlayed={singlesPlayed}
        gender={gender}
        isCurrentSeed={isCurrentSeed}
        points={points}
        change={change}
        playerRedirectURL={playerRedirectURL}
      />
    ) : (
      <SmallNonLive
        rank={rank}
        fullName={fullName}
        country={country}
        avatarUrl={avatarUrl}
        flagUrl={flagUrl}
        age={age}
        played={played}
        doublesPlayed={doublesPlayed}
        mixedPlayed={mixedPlayed}
        singlesPlayed={singlesPlayed}
        gender={gender}
        isCurrentSeed={isCurrentSeed}
        points={points}
        change={change}
        playerRedirectURL={playerRedirectURL}
      />
    )
  ) : big ? (
    <BigLive
      rank={rank}
      age={age}
      fullName={fullName}
      country={country}
      avatarUrl={avatarUrl}
      flagUrl={flagUrl}
      livePoints={livePoints}
      change={change}
      currentTournamentUrl={currentTournamentUrl}
      currentTournamentText={currentTournamentText}
      officialPoints={officialPoints}
      plusMinus={plusMinus}
      nextPoints={nextPoints}
      maxPoints={maxPoints}
      playerRedirectURL={playerRedirectURL}
    />
  ) : (
    <SmallLive
      rank={rank}
      age={age}
      fullName={fullName}
      country={country}
      avatarUrl={avatarUrl}
      flagUrl={flagUrl}
      livePoints={livePoints}
      currentTournamentUrl={currentTournamentUrl}
      currentTournamentText={currentTournamentText}
      officialPoints={officialPoints}
      plusMinus={plusMinus}
      nextPoints={nextPoints}
      maxPoints={maxPoints}
      change={change}
      playerRedirectURL={playerRedirectURL}
    />
  );
};
